
// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import RotatingCard from "parts/Cards/RotatingCard";
import RotatingCardFront from "parts/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "parts/Cards/RotatingCard/RotatingCardBack";
import DefaultInfoCard from "parts/Cards/InfoCards/DefaultInfoCard";

// Images
import bgFront from "assets/images/34.jpg";
import bgBack from "assets/images/35.jpg";

function Information() {
  return (
    <MKBox component="section" py={6} my={6}>
      <Container>
        <Grid container item xs={11} spacing={3} alignItems="center" sx={{ mx: "auto" }}>
          <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgFront}
                icon="touch_app"
                title={
                  <>
                     Build. 
                    <br />
                    Scale.
                  </>
                }
                description="Shaping digital solutions that grow with your business."
              />
              <RotatingCardBack
                image={bgBack}
                icon="touch_app"
                title={
                  <>
                     Creating. 
                    <br />
                    Evolve.
                  </>
                }
                description="Innovating at every stage to ensure lasting digital success."
              
              />
            </RotatingCard>
          </Grid>
          <Grid item xs={12} lg={7} sx={{ ml: "auto" }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="devices"
                  title="Build"
                  description="Crafting cutting-edge mobile and web solutions from the ground up, we transform visionary ideas into tangible realities. From concept to completion, our team meticulously designs and develops bespoke applications that set benchmarks in functionality, aesthetics, and performance. We are dedicated to creating innovative solutions that meet your unique business needs, ensuring a robust foundation for digital success."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="devices"
                  title="Transform"
                  description="Turning ideas into powerful digital experiences, we redefine the way businesses connect with their audiences. Our transformative approach combines intuitive design, seamless functionality, and user-centered innovation. By bridging creativity and technology, we bring your vision to life, crafting platforms that captivate, engage, and inspire."
                />
              </Grid>
            </Grid>
            <Grid container spacing={3} sx={{ mt: { xs: 0, md: 6 } }}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="devices"
                  title="Empower"
                  description="Equipping businesses with tools to lead in the digital space, we deliver advanced solutions tailored to your goals. Our expertise empowers you to stay ahead of the curve, providing the resources and technology needed to thrive in an ever-evolving market. By enabling efficiency, scalability, and growth, we help you unlock your full potential."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="devices"
                  title="Thrive"
                  description="Driving growth and success through innovative technology, we enable organizations to achieve their highest aspirations. Our solutions foster long-term sustainability, enhancing operational performance and market impact. With a relentless focus on results, we ensure that your business not only adapts but thrives in the dynamic digital landscape."
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
